// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcf_a bhl_wl","LoadingPlaceholder":"bcf_b bhl_h","loading-placeholder":"bcf_c"};